import React from 'react';
import xtend from 'xtend';
var h = React.createElement;
import S from 'pull-stream';
import _ from 'underscore';
import ViewStream from '@invintus/react-pull-stream';
import withLatest from 'pull-with-latest';
import join from 'pull-flat-merge';
import Pushable from 'pull-pushable';
import many from 'pull-many';
import View from '../../ott/view/roku/OttRoku';
import RokuModel from '../../ott/model/roku';
import combineLatest from 'pull-combine-latest';
import AssetModel from '../../ott/model/assets';
import requests from '../../ott/lib/requests';
// import Log from '../../lib/log';
import Ev from '../../lib/event';
import queryString from '../../utils/QueryString';
import ErrorPage from '../../landing/error/Error';

function OttRokuRoute (api, socket, opts, match) {
    // user auth
    if (!hasPermission('manage_ott.read,manage_ott.create,manage_ott.update')) {
        return function NotFound (props) {
            return h(ErrorPage, { code: 401 }, []);
        };
    }

    var viewStream = ViewStream(View);
    var viewSource = broadcast(viewStream.source);
    var store = RokuModel.store();
    // var log = Log();
    var assetsWs = Pushable();
    socket.assets(assetsWs.push);

    // if (process.env.NODE_ENV === 'development') {
    //     window.push = viewStream.source.push;
    // }

    // QUERY STRING
    // @TODO client side routing will pass in the query string
    var qsParams = queryString.parse(window.location.search);
    var channelID = qsParams.id;

    // we have to do this here because of the way routing works. The
    // sever does not pass the querystring into the router, we parse it
    // client side
    if (!channelID) return function NotFound (props) {
        return h(ErrorPage, { code: 404 }, []);
    };

    var sources = combineLatest({
        roku: S(
            withLatest(
                null,
                store.state(),
                S(
                    viewSource(),
                    S.map(function (ev) { // send channelID on save events
                        return Ev.type(ev) === 'saveJob' ?
                            Ev('saveJob', xtend(ev[1], {
                                ottChannelID: channelID
                            })) :
                            ev;
                    })
                )
            ),
            S.map(RokuModel.effects(api)),
            join(),
            // S.through(console.log.bind(console, 'event')),
            // S.through(function (ev) {
            //     log.push(Ev('event', ev));
            // }),
            store
            // S.through(_.compose( log.push, Ev('state') ))
        ),

        assets: S(
            many([
                S(
                    assetsWs,
                    S.map(function (msg) {
                        return Ev(msg.action.type, msg.data);
                    }),
                    S.filter(function (ev) {
                        return Ev.type(ev) === 'add';
                    })
                ),
                requests('get', api.assets.getMiscAssets.bind(api.assets, {
                    advancedDetails: true
                }))
            ]),
            AssetModel.store()
        )
    });

    S(
        sources,
        S.map(function (state) {
            return xtend(state.roku, {
                assets: xtend(state.assets, {
                    data: _.toArray(state.assets.data)
                        .sort()
                        .filter(function (asset) {
                            return asset.type === 'image';
                        })
                })
            });
        }),
        // S.through(console.log.bind(console, 'state')),
        viewStream.sink
    );

    return viewStream.view;
}


// ------------------------------------------------

import Notify from 'pull-notify';
import { hasPermission } from '../../lib/components/form/RestrictedComponent';
function broadcast (source) {
    var n = Notify();
    S( source, S.drain(n, n.abort) );
    return n.listen;
}

export default OttRokuRoute;
